// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout-module--main--27m5H","hasTakeover":"Layout-module--hasTakeover--ygljU","navOpen":"Layout-module--navOpen--2XvWP"};